import { JSX, useEffect } from 'react';
import { NokMini } from "../../../../types/entities";
import {
    useRecordContext
} from 'react-admin';
import { DefaultAdminUserMiniManagement } from "./DefaultAdminUserMiniManagement";
import { EmailFinderManagerContainer } from "./manager/email-finder/EmailFinderManagerContainer";
import { MysteryShopperManagerContainer } from "./manager/mystery-shopper/MysteryShopperManagerContainer";

export const MiniConfigurationManagementContainer: (props: any) => JSX.Element = (props: any): JSX.Element => {
    const record: NokMini = useRecordContext();

    const miniManagedList = {
        'email_finder': <EmailFinderManagerContainer />,
        // 'mystery_shopper': <MysteryShopperManagerContainer />,
    }

    return (
        <>
            { miniManagedList[record?.systemCode] ?? <DefaultAdminUserMiniManagement message="Configuration not yet available"  /> }
        </>
    );

}